import {ElmFrameworkPorts, handlePortLoopback} from "../../ElmFrameworkPorts";

export {
  handleAuth,
}
function handleAuth(isHybrid: boolean, ports: ElmFrameworkPorts): void {
  handlePortLoopback({
    portOut: ports.authErrorLoopback,
    portIn: ports.authErrorLoopbackSub,
  });
}
